export default __webpack_public_path__ + "static/media/orphanswords-ascent-cover.2539b3ef.jpg";